import {actions} from './actions';
import {mutations} from './mutations';
import * as getters from './getters';
import { state } from './state';

/** @type {import('vuex').Module<typeof state>} */
const mod = {
  namespaced: true,
  state: () => ({...state}),
  actions,
  mutations,
  getters
};


export default mod;